import {defineField, defineType} from 'sanity'
import {MdOutlineAutoAwesomeMosaic} from 'react-icons/md'

export default defineType({
  name: 'posts-by-category',
  title: 'Posts by Category',
  type: 'object',
  icon: MdOutlineAutoAwesomeMosaic,
  fields: [
    defineField({
      name: 'title',
      type: 'string',
      description: 'if title is not provided, the category title will be used',
    }),
    defineField({
      name: 'category',
      type: 'reference',
      to: [{type: 'blog.category'}],
    }),
    defineField({
      name: 'limit',
      description: 'Number of posts to display',
      type: 'number',
      initialValue: 6,
      validation: (Rule) => Rule.min(1),
    }),
  ],
  preview: {
    select: {
      title: 'title',
      categoryTitle: 'category.title',
    },
    prepare: ({title, categoryTitle}) => {
      return {
        title: title || categoryTitle,
      }
    },
  },
})
